import { render, staticRenderFns } from "./LocaleDropdown.vue?vue&type=template&id=e585e6cc&scoped=true&"
import script from "./LocaleDropdown.vue?vue&type=script&lang=js&"
export * from "./LocaleDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e585e6cc",
  null
  
)

export default component.exports